module.exports = __webpack_public_path__ + "static/media/icon_excel.f42f7ede.svg";